module.exports = __webpack_public_path__ + "img/mugshot-8.77119dfc.jpg";